import React from "react";
import { ProfileRow } from "../ProfileRow";
import { renderValue } from "../renderValueHelper";
import { useTranslation } from "@helpers/translate";
import changeIcon from "@assets/images/icons/change-icon.svg";
import saveIcon from "@assets/images/icons/save-icon.svg";
import cancelIcon from "@assets/images/icons/cancel-icon.svg";

import "./index.sass";

export const FirstNameRow = ({
  firstName,
  editingField,
  editingValues,
  setEditingValues,
  firstNameInputRef,
  handleSaveField,
  setEditingField,
  savingField,
}) => {
  const { __ } = useTranslation();

  const normalizedFirstName =
    typeof firstName === "string" ? firstName.trim() : "";

  const hasFirstName = Boolean(normalizedFirstName);

  const currentValue =
    typeof editingValues.first_name === "string"
      ? editingValues.first_name
      : "";

  const canSave = Boolean(currentValue.trim());

  const cancelEditing = () => {
    setEditingField(null);

    setEditingValues((prev) => ({
      ...prev,
      first_name: normalizedFirstName,
    }));
  };

  const handleSave = () => {
    if (!canSave || hasFirstName) return;

    handleSaveField("first_name", currentValue.trim());
  };

  const value =
    editingField === "first_name" && !hasFirstName ? (
      <input
        ref={firstNameInputRef}
        type="text"
        className="profile-row__editable-input"
        value={currentValue}
        onChange={(event) => {
          setEditingValues((prev) => ({
            ...prev,
            first_name: event.target.value,
          }));
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            handleSave();
          }

          if (event.key === "Escape") {
            cancelEditing();
          }
        }}
        placeholder={__("verification.step1.firstName") || "First name"}
      />
    ) : (
      renderValue(normalizedFirstName)
    );

  let actions = null;

  if (!hasFirstName) {
    actions =
      editingField === "first_name" ? (
        <>
          <button
            type="button"
            onClick={handleSave}
            disabled={savingField === "first_name" || !canSave}
            className="profile-action__save profile-action__button"
          >
            <img src={saveIcon} alt="save" />
          </button>

          <button
            type="button"
            onClick={cancelEditing}
            disabled={savingField === "first_name"}
            className="profile-action__cancel profile-action__button"
          >
            <img src={cancelIcon} alt="cancel" />
          </button>
        </>
      ) : (
        <button
          type="button"
          className="profile-action__button"
          onClick={() => {
            setEditingField("first_name");

            setEditingValues((prev) => ({
              ...prev,
              first_name: "",
            }));
          }}
        >
          <img src={changeIcon} alt="change" />
        </button>
      );
  }

  return (
    <ProfileRow
      label={__("verification.step1.firstName")}
      value={value}
      actions={actions}
    />
  );
};
